var _TextComponent_ps, _TextComponent_state;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { replaceAndPreserveInnermostParentHtmlElement } from './replaceAndPreserveInnermostParentHtmlElement';
import { BaseComponent } from '../BaseComponent';
export class TextComponent extends BaseComponent {
    constructor(compRef, ps) {
        super(compRef);
        this.type = 'text';
        _TextComponent_ps.set(this, void 0);
        _TextComponent_state.set(this, {
            text: '',
        });
        __classPrivateFieldSet(this, _TextComponent_ps, ps, "f");
    }
    async init() {
        const data = __classPrivateFieldGet(this, _TextComponent_ps, "f").ds.components.data.get(this.compRef);
        __classPrivateFieldGet(this, _TextComponent_state, "f").text = data.text;
    }
    async text(text) {
        if (typeof text === 'undefined') {
            return __classPrivateFieldGet(this, _TextComponent_state, "f").text;
        }
        else {
            const dsItem = __classPrivateFieldGet(this, _TextComponent_ps, "f").ds.components.data.get(this.compRef);
            const maybeHtmlContent = dsItem.text || '';
            const newText = replaceAndPreserveInnermostParentHtmlElement(text, maybeHtmlContent);
            __classPrivateFieldGet(this, _TextComponent_state, "f").text = newText;
            __classPrivateFieldGet(this, _TextComponent_ps, "f").ds.components.data.update(this.compRef, {
                ...__classPrivateFieldGet(this, _TextComponent_ps, "f").ds.components.data.get(this.compRef),
                text: newText,
            });
            return;
        }
    }
}
_TextComponent_ps = new WeakMap(), _TextComponent_state = new WeakMap();
//# sourceMappingURL=TextComponent.js.map